// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Lpzf","requiredAsterisk":"Info_requiredAsterisk__3xCFC"};